/**
 * L0b 시작 화면 · 소셜 로그인 (시안 09 L0b · D108). 로그인하지 않은 사람의 첫 화면입니다.
 *
 * 골목 사진 전면 + 위 200px 먹색 55%→0, 아래 560px 0→92%(화면 아래까지 서서히). 아래에서 위로:
 * 하단 24 → 약관 링크 둘(이용약관 · 개인정보처리방침, 히어로챗과 같음) → 16 → 버튼 셋(카카오 · Google · Apple, components/SocialButtons) → 32 → 부제 → 8 → 워드마크 36/44
 * → 10 → 크림 마크 48. 로그인한 사람은 이 화면을 건너뜁니다(GuestOnly).
 *
 * - 처음 온 계정 → 가입 동의 → 첫 방문 S0a. 기존 계정 → 별채대화(첫 방문 중이면 멈춘 장면). /auth/done 이 가릅니다
 * - **이메일 진입은 없습니다**(시안 04 결정). 시험 · 심사 계정용 이메일 로그인은 워드마크를 3초 안에 다섯 번 누르면 /manual-login 이 열립니다
 *   (히어로챗 /manual-login 과 같은 숨은 길, 사용자 결정 2026-10-16)
 * - 취소 · 실패하고 돌아오면 토스트 「로그인을 마치지 못했어요. 다시 해 볼까요?」
 */
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { WordmarkStack } from '../../components/Brand.jsx';
import { SocialButtons } from '../../components/SocialButtons.jsx';
import { SceneBackdrop } from '../welcome/SceneCards.jsx';

export const LOGIN_FAILED_MESSAGE = '로그인을 마치지 못했어요. 다시 해 볼까요?';
const SECRET_TAPS = 5;
const SECRET_WINDOW_MS = 3000;
const TOAST_MS = 4000;

export function StartPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [toast, setToast] = useState(location.state?.loginFailed ? LOGIN_FAILED_MESSAGE : null);
    const taps = useRef([]);

    useEffect(() => {
        if (location.state?.loginFailed) {
            // 새로 고침하면 다시 뜨지 않게 기록에서 지웁니다
            navigate(location.pathname, { replace: true, state: null });
        }
    }, []);

    useEffect(() => {
        if (!toast) {
            return undefined;
        }
        const timer = setTimeout(() => setToast(null), TOAST_MS);
        return () => clearTimeout(timer);
    }, [toast]);

    const tapBrand = () => {
        const now = Date.now();
        taps.current = [...taps.current.filter((at) => now - at < SECRET_WINDOW_MS), now];
        if (taps.current.length >= SECRET_TAPS) {
            taps.current = [];
            navigate('/manual-login', { state: { mode: 'login' } });
        }
    };

    return (
        <SceneBackdrop image="alley" top={200} topOpacity={0.55} bottom={560} bottomOpacity={0.92} bottomFrom={100}>
            <main className="relative flex min-h-dvh flex-1 flex-col items-center justify-end px-4 pb-[max(24px,env(safe-area-inset-bottom))]">
                {/* 숨은 길이라 눌러지는 표시를 두지 않습니다(버튼 역할 · 포커스 없음) */}
                <div onClick={tapBrand}>
                    <WordmarkStack
                        textSize={36}
                        lineHeight={44}
                        markSize={48}
                        tone="cream"
                        subtitle="차 한 잔 내어 줄게, 쉬었다 가"
                    />
                </div>
                <div className="mt-8 flex flex-col self-stretch">
                    <SocialButtons onNotice={setToast} />
                </div>
                {/* 약관 두 링크만(히어로챗 문 화면과 같음). 동의 문장은 두지 않습니다: 동의는 가입 동의 화면이 받습니다 */}
                <p className="mt-4 mb-0 flex items-center gap-2 text-[12px] leading-[18px] text-[#D8CFC2]">
                    <Link to="/legal/terms" className="text-inherit underline">
                        이용약관
                    </Link>
                    <span aria-hidden="true">·</span>
                    <Link to="/legal/privacy" className="text-inherit underline">
                        개인정보처리방침
                    </Link>
                </p>
                {toast ? (
                    <p
                        role="status"
                        className="absolute inset-x-4 top-[max(24px,env(safe-area-inset-top))] m-0 rounded-card bg-[rgba(38,35,31,0.92)] px-4 py-3 text-center text-[14px] leading-[22px] text-bg"
                    >
                        {toast}
                    </p>
                ) : null}
            </main>
        </SceneBackdrop>
    );
}
